export default __webpack_public_path__ + "static/media/e14-family.3a230d11.svg";